export default __webpack_public_path__ + "images/pages/quiz/categories/mobile_skincare-8a2acd53a778888735ae729454a888de.svg";